import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { UserPlus } from "lucide-react";
import { useT } from "@/context/LangContext";

export default function Register() {
  const t = useT();
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(name, email, password);
      nav("/dashboard", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="register-page">
      <div className="w-full max-w-md card-flat p-10">
        <p className="kicker">{t("auth.register.kicker")}</p>
        <h1 className="font-display text-3xl font-black mt-3">{t("auth.register.title")}</h1>
        <p className="text-[var(--ink-soft)] mt-2 text-sm">{t("auth.register.desc")}</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          {err && <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded text-sm" data-testid="register-error">{err}</div>}
          <input required value={name} onChange={(e) => setName(e.target.value)} placeholder={t("auth.name")} className="input-field" data-testid="register-name" />
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")} className="input-field" data-testid="register-email" />
          <input type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("auth.passwordMin")} className="input-field" data-testid="register-password" />
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit">
            {loading ? t("auth.register.loading") : <>{t("auth.register.submit")} <UserPlus size={16} /></>}
          </button>
        </form>

        <p className="text-sm text-[var(--ink-soft)] mt-6 text-center">
          {t("auth.register.have")} <Link to="/login" className="font-semibold text-[var(--accent)]" data-testid="link-login">{t("auth.register.login")}</Link>
        </p>
      </div>
    </div>
  );
}
